import React from 'react';

import ReactSwitch, { ReactSwitchProps } from 'react-switch';

import { Tokens } from '../../types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Switch = ReactSwitch as any;

const theme = Tokens.eixods;
const ToggleSwitch: React.FC<ReactSwitchProps> = ({ ...props }) => (
  <Switch
    {...props}
    data-testid="toggle-switch"
    uncheckedIcon={false}
    checkedIcon={false}
    handleDiameter={20}
    onColor={theme.colors.brand.primary[100]}
    offColor={theme.colors.brand.secondary[100]}
  />
);

export default ToggleSwitch;
